import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { StorySection } from '../components/sections/StorySection';
import { MechanismSection } from '../components/sections/MechanismSection';
import { DeliverablesSection } from '../components/sections/DeliverablesSection';
import { AudienceSection } from '../components/sections/AudienceSection';
import { HowItWorksSection } from '../components/sections/HowItWorksSection';
import { ProofSection } from '../components/sections/ProofSection';
import { FAQSection } from '../components/sections/FAQSection';
import { OfferSection } from '../components/sections/OfferSection';
import { Footer } from '../components/sections/Footer';
export function SalesPage() {
  return <main className="min-h-screen bg-brand-navy text-brand-gray font-dmsans selection:bg-brand-gold selection:text-brand-navy" data-id="element-205">
      <HeroSection data-id="element-206" />
      <StorySection data-id="element-207" />
      <MechanismSection data-id="element-208" />
      <DeliverablesSection data-id="element-209" />
      <AudienceSection data-id="element-210" />
      <HowItWorksSection data-id="element-211" />
      <ProofSection data-id="element-212" />
      <FAQSection data-id="element-213" />
      <OfferSection data-id="element-214" />
      <Footer data-id="element-215" />
    </main>;
}